module.exports = __webpack_public_path__ + "web/img/画板 13687.4e0766ea.png";